export const thunkTypes = {
  SUBMIT_PROBLEM_REPORT: `problemReport/submit`,
};
